import * as React from "react";
import ShimmerDashboard from "../../../../Assets/Loaders/ShimmerEffect";

const CommisionURL = process.env.REACT_APP_CommisionURL;
const AgencyCommisionURL = process.env.REACT_APP_AgencyCommisionURL;
const Commission = ({ agentID, agencyId }) => {
    const [loader, setLoader] = React.useState(true);

    const [commissionPopup, setCommissionPopup] = React.useState(false);
    const wrapRef = React.useRef(null);
    const [frameHeight, setFrameHeight] = React.useState(500);

    // Fill the space from the top of this tab to the bottom of the window, like the other tabs.
    React.useEffect(() => {
      const fit = () => {
        if (!wrapRef.current) return;
        const top = wrapRef.current.getBoundingClientRect().top;
        setFrameHeight(Math.max(320, Math.floor(window.innerHeight - top - 12)));
      };
      fit();
      const t = setTimeout(fit, 300);
      window.addEventListener("resize", fit);
      return () => { clearTimeout(t); window.removeEventListener("resize", fit); };
    }, []);
    React.useEffect(() => {
      window.addEventListener("message", (event) => {
        try {
          const eventData = JSON.parse(event.data);
          if (eventData.hasOwnProperty("isFullScreen")) {
            const isFullScreen = eventData.isFullScreen;
            setCommissionPopup(isFullScreen);
          }
        } catch (error) {
          console.error("Error parsing message data:", error);
        }
      });
    }, []);

  return (
    <div ref={wrapRef} style={commissionPopup ? {
        position: "fixed",
        inset: 0,
        zIndex: 10000
    } : {}}>
      {loader && <div style={{ height: commissionPopup ? "100vh" : frameHeight }}>
        <ShimmerDashboard onlyTable={true}/>
      </div>}
      <iframe
        src={agencyId ? `${AgencyCommisionURL}${btoa(agencyId)}` : `${CommisionURL}${btoa(agentID)}`}
        style={{
          ...(commissionPopup ? styleCommission : { ...style, height: frameHeight }),
          display: loader ? "none" : "block"
        }}
        onLoad={() => setLoader(false)}
      />
    </div>
  );
};


export default Commission;

const style = {
  width: "100%",
  height: 500,
  border: "none",
  margin: "auto",
};
const styleCommission = {
  width: "100%",
  height: "100vh",
  border: "none",
  margin: "auto",
};
